import { useState } from 'react'

export const usePasswordInput = () => {
  const [showPassword, setShowPassword] = useState(false)

  const togglePasswordVisibility = () => {
    setShowPassword(showPassword => !showPassword)
  }

  return { togglePasswordVisibility, showPassword }
}
